/**
 * Component: Image Slider
 */

var dnDepartments = dnDepartments || {};

dnDepartments.stickyMenu = dnDepartments.stickyMenu || function () {
	this.init = function () {

		if($(window).width() > 992) {
			// Create a clone of the menu, right next to original.
			$('.navigation-department').addClass('original').clone().insertAfter('.navigation-department').addClass('cloned').removeClass('original').hide();

			scrollIntervalID = setInterval(stickIt, 10);
		}
	};
	
	function stickIt() {
		var orgElementPos = $('.original').offset();
		orgElementTop = orgElementPos.top;               

		if ($(window).scrollTop() >= (orgElementTop)) {
			// scrolled past the original position; now only show the cloned, sticky element.

			// Cloned element should always have same left position and width as original element.     
			orgElement = $('.original');
			coordsOrgElement = orgElement.offset();
			leftOrgElement = coordsOrgElement.left;  
			widthOrgElement = orgElement.css('width');
			$('.cloned').css('left',leftOrgElement+'px').css('top',0).css('width',widthOrgElement).show();
			$('.original').css('visibility','hidden');
		} else {
			// not scrolled past the menu; only show the original menu.
			$('.cloned').hide();
			$('.original').css('visibility','visible');
		}
	}

	return {
		init: init
	}
}();